import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, Lock, ShieldCheck } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("office.forexdigitec@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] das-grid px-4">
      <div className="w-full max-w-md das-fade">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 border border-white/10 bg-white/[0.03] px-3 py-1 rounded-sm mb-5">
            <ShieldCheck size={14} className="text-[#00FF66]" />
            <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-400">
              Secure Access Vault
            </span>
          </div>
          <h1 className="font-display text-4xl font-bold tracking-tighter">DASARRO</h1>
          <p className="text-sm text-zinc-500 mt-2 font-mono uppercase tracking-widest">
            Agency Operations Backend
          </p>
        </div>

        <div className="bg-[#121212] border border-white/10 rounded-sm p-8 shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1.5 block">
                Email
              </label>
              <div className="relative">
                <KeyRound size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-600" />
                <input
                  data-testid="login-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full bg-[#050505] border border-white/10 text-white rounded-sm pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:border-white focus:ring-1 focus:ring-white transition-colors"
                  placeholder="you@dasarro.com"
                />
              </div>
            </div>

            <div>
              <label className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1.5 block">
                Password
              </label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-600" />
                <input
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full bg-[#050505] border border-white/10 text-white rounded-sm pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:border-white focus:ring-1 focus:ring-white transition-colors"
                  placeholder="••••••••"
                />
              </div>
            </div>

            {error && (
              <div
                data-testid="login-error"
                className="text-sm text-[#FF6259] bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded-sm px-3 py-2"
              >
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black font-medium py-2.5 rounded-sm hover:bg-zinc-200 transition-colors active:scale-[0.98] disabled:opacity-60"
            >
              {loading ? "Authenticating…" : "Enter Command Center"}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-zinc-600 mt-6 font-mono">
          Dasarro Technologies · Restricted internal system
        </p>
      </div>
    </div>
  );
}
